module.exports = __webpack_public_path__ + "img/shoplogo.a963bf6b.svg";